<template>
    <form @submit.prevent="store" class="form-signin">
        <h1 class="h3 mb-3 font-weight-normal">{{ $t('Вход') }}</h1>

        <div class="form-group">
            <label for="inputEmail">{{ $t('Email') }}</label>
            <input type="email"
                id="inputEmail"
                :class="{'form-control': true, 'is-invalid': hasError('login')}"
                placeholder="Email"
                required
                v-model="form.login"
                autofocus />
        </div>
        <span class="invalid-feedback d-block" v-if="hasError('login')">{{ getError('login') }}</span>

        <div class="form-group">
            <label for="inputPassword" class="password-group">
                <span>{{ $t('Пароль') }}</span>

                <router-link to="/restore" class="btn btn-link btn-restore">{{ $t('Забыли пароль?') }}</router-link>
            </label>
            <input type="password"
                    id="inputPassword"
                    :class="{'form-control': true, 'is-invalid': hasError('password')}"
                    :placeholder="$t('Пароль')"
                    v-model="form.password"
                    required />
        </div>
        <span class="invalid-feedback" v-if="hasError('password')" v-text="getError('password')"></span>

        <button class="btn btn-blue btn-login" :disabled="formDisabled" type="submit">{{ $t('Войти') }}</button>

        <router-link to="/register" class="btn btn-link text-center">{{ $t('У меня нет аккаунта') }}</router-link>

        <button class="btn btn-google btn-social" @click="authWith('google')" type="button">{{ $t('Войти с помощью') }} Google</button>
        <button class="btn btn-facebook btn-social" @click="authWith('facebook')" type="button">{{ $t('Войти с помощью') }} Facebook</button>
        <button class="btn btn-apple btn-social" @click="authWith('apple')" type="button">{{ $t('Войти с помощью') }} Apple</button>
    </form>
</template>

<script>
import { EventBus } from '@/event-bus.js';

export default {
    name: "Login",

    data: function() {
        return {
            form: {
                login: null,
                password: null
            },

            errors: {},
        };
    },

    watch: {
        'form.login': function() {
            delete this.errors['login'];
        },
        'form.password': function() {
            delete this.errors['password'];
        },
    },

    computed: {
        isTestAuth: function() {
            return location.hash == '#test-auth';
        },

        formDisabled: function() {
            return this.form.login === null || this.form.login === ''
                || this.form.password === null || this.form.password === ''
                || this.form.login.indexOf('@') === -1;
        }
    },

    mounted() {
        let query = new URLSearchParams(location.search);

        if(query.has('auth')) {
            if(query.get('isError') != 0) {
                let errorMessage = query.get('error') == 'email_exists' 
                    ? this.$t('Email уже занят, войдите используя пароль') 
                    : this.$t('Во время авторизации произошла ошибка');

                EventBus.$emit('show-alert', errorMessage, 'error');
            } else {
                if(query.has('code')) {
                    this.getUserTokenUsingCode(query.get('code'), (message) => {
                        let alertMessage = query.get('isRegistered') == 1
                            ? this.$t('Вы были успешно зарегестрированы')
                            : message

                        EventBus.$emit('show-alert', alertMessage, 'success');
                    })
                }
            }
        }        
    },

    methods: {
        authWith(driver) {

            this.$ga.event({
                eventCategory: "socialAuthButton",
                eventAction: "requestAuth",
            });

            location.href = `https://${process.env.VUE_APP_AUTH_SERVICE}/social/${driver}/redirect?redirect_to=${location.href}`
        },

        getUserTokenUsingCode(code, callback = () => {}) {
            axios.post(`/auth/code`, {code: code})
                .then(({data}) => {
                    const token = data.data.token;

                    const user = data.data.user;

                    this.$ga.event({
                        eventCategory: "socialAuthButton",
                        eventAction: "successAuthentication",
                    });

                    callback(data.message);

                    this.loginUsingToken(token, user);
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : this.$t('Неизвестная ошибка'), 'error');   
                    }

                    EventBus.$emit('show-alert', this.$t('При авторизации через социальную сеть произошла ошибка, повторите попытку'), 'error'); 
                    location.search = '';
                });
        },

        loginUsingToken(token, user) {
            localStorage.setItem('token', token);

            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

            this.$store.commit('auth_success', token, user);

            location.href = '/';
        },

        store() {
            axios.post(`/auth/login`, this.form)
                .then(({data}) => {
                    const token = data.data.token;

                    const user = data.data.user;

                    this.$ga.event({
                        eventCategory: "authButton",
                        eventAction: "successAuthentication",
                    });

                    this.loginUsingToken(token, user);
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : this.$t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        hasError(name) {
            return this.errors[name] !== undefined;
        },
        
        getError(name) {
            if(this.hasError(name)) {
                return this.errors[name][0].replace(name, '');
            }

            return "";
        },
    }
};
</script>

<style scoped lang="scss">
.form-signin {
    width: 100%;
    padding: 0 30%;
    display: flex;
    flex-direction: column;

    .form-group {
        display: flex;
        flex-direction: column;
        margin-bottom: 10px;

        label {
            margin-bottom: 0;
        }
    }

    .password-group {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .btn-restore {
        text-align: right;
        padding: 0;
        font-size: 12px;
    }

    .btn-social {
        margin: 2px 0;
    }
}
</style>